import React from 'react';
import './BMS.css';
import FMSimage from '../Assets/bms11.jpg'; // First image
import FMSimage2 from '../Assets/bmscell.jpeg'; // Image for Key Features & Benefits
import FMSvideo3 from '../Assets/bbbb.mp4'; // Video for How it Works section (replaced FMSimage3)
import FMSimage4 from '../Assets/bmsd.jpeg'; // Image for Why Choose section
import FMSimage5 from '../Assets/bms4.jpg'; // Image for Industries section

const FMS = () => {
    return (
        <div className="FMS-card">
            <div className="FMS-container">
                {/* First Section: Layout for Text and Image */}
                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <h1 className="FMS-heading">BATTERY MANAGEMENT SYSTEM</h1>
                        <p className="FMS-description">
                            Our Battery Management System (BMS) continuously monitors battery health to ensure optimal performance and safety. By tracking individual cell conditions, it prevents voltage imbalances that affect control and distribution systems, enhancing decisions on mission profiles, safety, and maintenance.
                        </p>
                    </div>

                    {/* Right side: Image */}
                    <div className="FMS-image-container">
                        <img src={FMSimage} alt="Battery Management" className="FMS-image" />
                    </div>
                </div>

                {/* Centered Heading Between Images */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
                </div>

                {/* Second Section: New Layout for Text and Image */}
                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            <ul>
                                <li><strong>Real-Time Monitoring:</strong> Tracks string voltage, current, and ambient temperature.</li>
                                <li><strong>SoC & DoD Estimation:</strong> Accurately estimates State of Charge and Depth of Discharge.</li>
                                <li><strong>Real-Time Alerts:</strong> Generates alerts for low SoC, low/high voltage, and under/over voltage conditions.</li>
                                <li><strong>Charge-Discharge Tracking:</strong> Records cycles and computes ampere hours (in & out).</li>
                                <li><strong>Configurable Thresholds:</strong> Allows over-the-air adjustments for cell voltage and terminal temperature alerts.</li>
                            </ul>
                        </p>
                    </div>

                    {/* Right side: Image for Key Features */}
                    <div className="FMS-image-container">
                        <img src={FMSimage2} alt="Key Features" className="FMS-image" />
                    </div>
                </div>

                {/* Centered Heading for How it Works */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">How it Works</h2>
                </div>

                {/* Third Section: Layout for How it Works */}
                <div className="FMS-content-container">
                    {/* Left side: Video */}
                    <div className="FMS-image-container">
                        <video className="FMS-image" autoPlay loop muted playsInline>
                            <source src={FMSvideo3} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>

                    {/* Right side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            The BMS uses advanced sensors to monitor string voltage, current, and ambient temperature in real time. It estimates State of Charge (SoC) and Depth of Discharge (DoD), tracks charge-discharge cycles, and computes ampere hours. Real-time alerts for low SoC, voltage anomalies, or temperature issues are sent via a centralized dashboard, with over-the-air configurable thresholds for proactive management.
                        </p>
                    </div>
                </div>

                {/* New Section: Why Choose Us */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Why Choose Our Battery Management System</h2>
                </div>

                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            Our BMS ensures reliable battery performance and safety, offering:
                            <ul>
                                <li>Continuous health monitoring for optimal voltage and safety</li>
                                <li>Real-time alerts for low SoC and voltage issues</li>
                                <li>Accurate SoC/DoD estimation for mission-critical decisions</li>
                                <li>Over-the-air configurable thresholds for flexibility</li>
                                <li>Extended battery life through precise cycle tracking</li>
                            </ul>
                        </p>
                    </div>

                    {/* Right side: Image */}
                    <div className="FMS-image-container">
                        <img src={FMSimage4} alt="Why Choose Us" className="FMS-image" />
                    </div>
                </div>

                {/* New Section: Industries Using Our BMS */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Industries Using Our BMS</h2>
                </div>

                <div className="FMS-content-container reverse-order-last">
                    {/* Left side: Image for Industries */}
                    <div className="FMS-image-container">
                        <img src={FMSimage5} alt="Industries Using BMS" className="FMS-image" />
                    </div>

                    {/* Right side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            Our Battery Management System is trusted by a variety of industries to ensure battery health, safety, and operational efficiency. These industries rely on our solution for its reliability, precision, and performance enhancement:
                            <ul>
                                <li>Automotive</li>
                                <li>Renewable Energy</li>
                                <li>Manufacturing</li>
                                <li>Telecommunications</li>
                                <li>Energy Storage</li>
                                <li>Logistics & Transportation</li>
                            </ul>
                        </p>
                    </div>

                    {/* Curved Bottom Section */}
                    <div className="wave-container">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                            <path fill="#ffffff" d="M0,224L48,213.3C96,203,192,181,288,149.3C384,117,480,75,576,80C672,85,768,139,864,170.7C960,203,1056,213,1152,213.3C1248,213,1344,203,1392,197.3L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FMS;